import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginPage from "pages/master/login"

const PageRoutes = () => {
  return (
    <Routes>

     
      <Route path="*" element={<LoginPage></LoginPage>} />
    </Routes>
  );
};

export default React.memo(PageRoutes);
